<template>
  <VModal
      :title="question.id ? 'ویرایش سوال ' : 'ایجاد سوال'"
      :show="show">

    <VAlert class="mt-4" type="danger" v-if="errors.length > 0">
      <div v-for="(error, index) in errors"
           :key="error" :class="{'font-bold' : index === 0}">
        {{ index !== 0 ? '- ' + error : error }}
      </div>
    </VAlert>

    <form @submit.prevent="submit" ref="form">
      <input type="hidden" name="_method" value="PUT" v-if="question.id">

      <fieldset class="border rounded p-4 mt-4 pt-0">
        <legend>سوال نظرسنجی</legend>

        <div v-for="lang in languages" :key="lang.id" class="mt-4">
          <label>سوال {{ lang.name }}</label>
          <VInput
              type="text"
              :name="'question_' + lang.code"
              :value="$helper.getTextValue(lang, question.question_text)"
              placeholder="سوال"
              class="mt-4"
              :required="lang.code === 'fa'"/>
        </div>
      </fieldset>

      <div class="flex items-center justify-between mt-8">
        <div>
          <label>وضعیت سوال</label>
          <h6 class="mt-1 text-sm text-muted">در صورت غیرفعال بودن سوال، سوال نمایش داده نمیشود</h6>
        </div>

        <VSwitch v-model="active" :value="question.active"/>
      </div>

      <VButton type="submit" class="mt-10 w-full">ثبت</VButton>

      <VLoadingScreen :show="loading"/>
    </form>

  </VModal>
</template>

<script>
import VModal from "@/components/General/VModal";
import VInput from "@/components/General/VInput";
import VSwitch from "@/components/General/VSwitch";
import VButton from "@/components/General/VButton";
import {createSurveyQuestion, updateSurveyQuestion} from "@/API/API";
import VAlert from "@/components/General/VAlert";
import VLoadingScreen from "@/components/General/VLoadingScreen";
import {mapState} from "vuex";

export default {
  name: "ModalSurveyQuestion",
  components: {VLoadingScreen, VAlert, VButton, VSwitch, VInput, VModal},
  props: {
    show: Boolean,
    question: {
      default: () => ({})
    }
  },
  data() {
    return {
      active: 1,
      loading: false,
      errors: [],
    }
  },
  computed: {
    ...mapState(['languages'])
  },
  methods: {
    submit() {
      this.loading = true
      this.errors = []

      let question = new FormData(this.$refs.form)
      question.append('active', this.active)

      if (this.question.id) {
        this.updateSurveyQuestion(question)
      } else {
        this.createSurveyQuestion(question)
      }
    },
    updateSurveyQuestion(question) {
      updateSurveyQuestion(this.question.id, question)
          .then(resp => this.$emit('edited', resp.data))
          .catch(err => this.$helper.validationError(err, this.errors))
          .finally(() => this.loading = false)
    },
    createSurveyQuestion(question) {
      createSurveyQuestion(question)
          .then(resp => this.$emit('created', resp.data))
          .catch(err => this.$helper.validationError(err, this.errors))
          .finally(() => this.loading = false)
    }
  }

}
</script>

<style scoped>

</style>